/**
 * Find the single row key that was added between two renders.
 *
 * Used to scroll a freshly added row into view. Deliberately conservative: it
 * stays silent on the first load and on bulk arrivals, so the table only jumps
 * when the user actually added one item.
 *
 * @param {Array<string>} previousKeys
 * @param {Array<string>} nextKeys
 * @returns {string|null} The added key, or null when nothing should scroll.
 */
const findNewRowKey = (previousKeys, nextKeys) => {
    if (!Array.isArray(previousKeys) || !Array.isArray(nextKeys)) return null;

    // First snapshot — the whole list is "new", scrolling would be a jump.
    if (previousKeys.length === 0) return null;

    // Removal or reorder, never an addition.
    if (nextKeys.length <= previousKeys.length) return null;

    const seen = new Set(previousKeys);
    const added = nextKeys.filter((key) => !seen.has(key));

    // A bulk load is not a user action — don't move the viewport.
    if (added.length !== 1) return null;

    return added[0];
};

export default findNewRowKey;
